export default () => {
  const apiRequest = useApiRequest();
  const vehicleBaseUrl = 'reports/vehicle/';
  return {
    /* -------------------------------------------------------------------------- */
    /*                                    Vehicles                                    */
    /* -------------------------------------------------------------------------- */

    /**
     * Gets a list of Vehicles, potentially filtered.
     *
     * @param filters
     */
    getAllVehicles: (investigationReportId: number) =>
      apiRequest.get<Page<Vehicle>>(`${vehicleBaseUrl}?investigationreport=${investigationReportId}`),

    /**
     * Creates a new vehicle
     *
     * @param report
     */
    createVehicle: (report: Partial<VehicleChanges>, id: number) => {
      report.investigationreport = id;
      apiRequest.post<Vehicle>(vehicleBaseUrl, { body: report });
    },

    /**
     * Get a specific investigation report
     *
     * @param id
     */
    getVehicle: (id: number) =>
      apiRequest.get<Vehicle>(`${vehicleBaseUrl}${id}/`),

    /**
     * Search for vehicles based on a text string
     *
     * @param id
     */
    searchVehicles: (params: any) =>
      apiRequest.get<Page<VehicleSearchResult>>(`${vehicleBaseUrl}`, { params }),

    /**
     * Updates a specific vehicle
     *
     * @param id
     */
    updateVehicle: (id: number, data: Partial<VehicleChanges>) =>
      apiRequest.patch<Vehicle>(`${vehicleBaseUrl}${id}/`, { body: data }),

    /**
     * Delete a specific vehicle.
     *
     * @param id
     */
    deleteVehicle: (id: number) =>
      apiRequest.delete<Vehicle>(`${vehicleBaseUrl}${id}/`),

  };
};
